export default "__VITE_ASSET__DZZjGkOP__"